import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupBaseDocuments } from "../../../Shared/NewForms/NFLookupBaseDocuments";
import { NFLookupPriceType } from "../../../Shared/NewForms/NFLookupPriceType";
import { NFLookupPeriod } from "../../../Shared/NewForms/NFLookupPeriod";

export const SetItemsPricesDetailsMain = () => {
  const { watch } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput
            title={t("Document#")}
            fieldName={"documentNumber"}
            disabled
          />
        </Col>
        <Col sm={6}>
          <NFDateInput
            title={t("DocumentDate")}
            fieldName={"documentDate"}
            required={true}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCompany fieldName={"companyId"} title={t("Company")} />
        </Col>
        <Col sm={6}>
          <NFLookupPriceType fieldName={"priceTypeId"} title={t("priceType")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupPeriod
            title={t("Period")}
            startTitle={t("From")}
            endTitle={t("To")}
            startDateFieldName={"documentDate"}
            endDateFieldName={"documentDate"}
            required={true}
          />
        </Col>
      </Row>
    </>
  );
};
